import firebase from 'firebase';
import _ from 'lodash';

import View from '../../_components/view/view.js';
import positionHistoryTpl from './position-history.tpl.html';
import './position-history.styles.less';

import playersService from '../../_services/players.service.js';
import groupsService from '../../_services/groups.service.js';

class PositionHistoryView extends View {

	constructor (data, options) {
		let viewOptions = {
			viewClass: 'position-history'
		};

		super(positionHistoryTpl, data, _.extend(options, viewOptions));

	}

	uiElements() {
		return _.extend(super.uiElements(), {
			scrollWrapper1: '.scroll-wrapper-1',
			scrollWrapper2: '.scroll-wrapper-2',
			dummyScroller: '.dummy-scroller',
			positionHistoryTable: '.position-history-table'
		});
	}

	render(data) {
		super.render(data);

		this.ui.scrollWrapper1.on('scroll', () => {
			this.ui.scrollWrapper2.scrollLeft(this.ui.scrollWrapper1.scrollLeft());
		});

		this.ui.scrollWrapper2.on('scroll', () => {
			this.ui.scrollWrapper1.scrollLeft(this.ui.scrollWrapper2.scrollLeft());
		});
	}

	initializeEvents() {
		//UI Events
		
		///Database Events
			
	}

	onShow() {
		var self = this;
		
		super.onShow();

		setTimeout(() => {
			self.ui.dummyScroller.width(self.ui.positionHistoryTable.width());
		}, 500);
	}

	/*removeNewsList() {
		_.forEach(this.newsViews, newView => {
			newView.remove();
		});

		this.newsViews = [];
	}*/

	remove() {
		/*this.removeNewsList();*/
		super.remove();
	}

}

export default PositionHistoryView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/history-section/position-history/position-history.view.js